import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { exchangeSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const target = location.pathname || "/account";
    exchangeSession(sessionId)
      .then(() => { window.history.replaceState(null, "", target); nav(target, { replace: true }); })
      .catch(() => { toast.error("Google sign-in failed. Please try again."); nav("/auth", { replace: true }); });
  }, [location, nav, exchangeSession]);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center text-indigo-deep/70 text-sm">
      Signing you in…
    </div>
  );
}
